import { ReactNode } from 'react'
import { useLayoutHeight } from '../../hooks/useLayoutHeight'
import * as Styled from './LayoutContent.styled'

export function LayoutContent({ children }: { children: ReactNode }) {
  const widgetHeight = useLayoutHeight()

  return <Styled.ContentContainer $widgetHeight={widgetHeight}>{children}</Styled.ContentContainer>
}
